import JSZip from "jszip";
import { VFile } from "vfile";

export function generateNonce(length: number = 8): string {
  const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

// oxfmt-ignore
const MEDIA_EXTS = new Set([
  ".jpg", ".jpeg", ".png", ".gif", ".webp", ".avif", ".heic", ".heif", ".bmp",
  ".tif", ".tiff", ".svg", ".mp4", ".mov", ".m4v", ".webm", ".mkv", ".avi",
  ".mp3", ".m4a", ".wav", ".ogg", ".flac", ".aac", ".dat",
]);

const isMedia = (name: string) => {
  const ext = new VFile({ path: name }).extname;
  return ext !== undefined && MEDIA_EXTS.has(ext.toLowerCase());
};

function isArchive(name: string) {
  const file = new VFile({ path: name });
  return file.extname?.toLowerCase() === ".zip";
}

let MAX_ARCHIVE_DEPTH: number | null = null;

export function setMaxArchiveDepth(depth: number | null) {
  MAX_ARCHIVE_DEPTH = depth;
}

export async function scrubArchive(blob: Blob, depth = 0) {
  const archive = await JSZip.loadAsync(blob);

  for (const path of Object.keys(archive.files)) {
    if (isMedia(path)) {
      archive.remove(path);
    }

    if (isArchive(path) && (MAX_ARCHIVE_DEPTH === null || depth < MAX_ARCHIVE_DEPTH)) {
      const file = archive.file(path);

      if (!file || file.dir) continue;

      const nested = await file.async("blob");
      const scrubbed = await scrubArchive(nested, depth + 1);
      archive.file(path, scrubbed);
    }
  }

  return archive.generateAsync({ type: "blob", compression: "DEFLATE" });
}
